import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useReadDefectiveTagsStepStyles } from './readDefectiveTagsStep.styles';

export function ReadDefectiveTagsStep({ description }) {
  const classes = useReadDefectiveTagsStepStyles();

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid xs={12} item className={classes.info}>
        <Info fontSize="large" className={classes.infoIcon}></Info>
        <Typography variant="subtitle1" component="div" className={classes.title}>
          {description}
        </Typography>
      </Grid>
    </Grid>
  );
}

ReadDefectiveTagsStep.propTypes = {
  description: PropTypes.string.isRequired
};
